/**
 * Enum representing cache keys.
 */
export enum CacheKeys {
  /**
   * Cache key for the home page.
   */
  HOME = 'HOME',
  /**
   * Cache key for fleet ratings.
   */
  FLEET_RATINGS = 'FLEET_RATINGS',
  /**
   * Cache key for fleet export.
   */
  FLEET_RATINGS_EXPORT = 'FLEET_RATINGS_EXPORT',
  /**
   * Cache key for cii simulator.
   */
  CII_SIMULATOR = 'CII_SIMULATOR',
  /**
   * Cache key for EEOI scores.
   */
  EEEOI_SCORES = 'EEEOI_SCORES',

  /**
   * Cache key for EEOI scores export.
   */
  EEOI_SCORES_EXPORT = 'EEOI_SCORES_EXPORT',

  /**
   * Cache key for fleet performance.
   */
  FLEET_PERFORMANCE = 'FLEET_PERFORMANCE',

  /**
   * Cache key for vessels.
   */
  VESSELS = 'VESSELS',

  /**
   * Cache key for vessel performance.
   */
  VESSEL_PERFORMANCE = 'VESSEL_PERFORMANCE',

  /**
   * Cache key for voyage performance.
   */
  VOYAGE_PERFORMANCE = 'VOYAGE_PERFORMANCE',

  /**
   * Cache key for voyages.
   */
  VOYAGES = 'VOYAGES',

  /**
   * Cache key for schedule list.
   */
  SCHEDULE_LIST = 'SCHEDULE_LIST',
}
